export const DEFAULT_PAGE_SIZES = [25, 50, 100];